import { createFileRoute, notFound } from '@tanstack/react-router';

// TODO: Restore the Data Management page (import/export platform config) once the backend
// fully supports the data-management APIs. When ready, re-import the lazy page and suspense
// fallback below and remove the `beforeLoad` notFound throw.
// See docs/changes/2026-04-23-hide-data-management-and-impersonate.md.
//
// import { lazy, Suspense } from 'react';
// import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
// const DataManagementPage = lazy(() => import('~/features/platform/pages/data-management-page'));

// Route is currently hidden: direct URL visits render the global 404 (root notFoundComponent).
// The nav entry has also been removed from platform-layout.tsx.
export const Route = createFileRoute('/_authenticated/_tenant/platform/data-management')({
  beforeLoad: () => {
    // TanStack Router uses throw notFound() as control flow — not an error.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw notFound();
  },
});
